// extracted by mini-css-extract-plugin
var _1 = "Shortcut-module__animateUploadProgressBarWidth--ISIFr";
var _2 = "Shortcut-module__animatedBackground--YNRB4";
var _3 = "Shortcut-module__isMono--KoVJy";
var _4 = "Shortcut-module__isSmall--gmjja";
var _5 = "Shortcut-module__shortcut--DyB7I";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "isMono", _4 as "isSmall", _5 as "shortcut" }
